import { Injectable, inject } from '@angular/core';

import { UserOddsFormatSettingsService } from '@frontend/sports/user/feature';

import { BetslipPick } from '../../../../../../core/picks/betslip-pick';
import { OddsChangedPreCheckError } from '../../../../errors/pre-check/odds-changed-pre-check-error';
import { PickValidationContext } from '../../../../models/models';
import { IContextPickValidator } from '../validators';
import { OddsChangedHelperService } from './odds-changed-helper.service';

@Injectable()
export class OddsChangedValidator implements IContextPickValidator<OddsChangedPreCheckError> {
    private readonly userOddsFormatSettingsService = inject(UserOddsFormatSettingsService);

    constructor(private oddsAcceptedHelperService: OddsChangedHelperService) {}

    validate(pick: BetslipPick, context: PickValidationContext): OddsChangedPreCheckError[] {
        const oddsAccepted = this.oddsAcceptedHelperService.areOddsAccepted(pick, context.settings.oddsAcceptance);

        if (oddsAccepted) {
            return [];
        }

        const pickId = pick.id.toString();
        const currentOdds = pick.currentPrice!.nativeOdds;
        const acceptedOdds = pick.acceptedPrice.price!.nativeOdds;

        return [new OddsChangedPreCheckError(pickId, currentOdds, acceptedOdds, this.userOddsFormatSettingsService.oddsFormat)];
    }
}
